<template>
  <dialog-modal-fi
    ref="modal"
    class="seminar-detail-dialog-fi"
    lazy
    full-screen
  >
    <template #body>
      <div
        v-if="description"
        class="seminar-detail-dialog-fi__text"
      >
        <richtext-fi :html-content="{ value: description }" />
      </div>
    </template>
  </dialog-modal-fi>
</template>

<script setup lang="ts">
import { DialogModalFi, RichtextFi } from 'atoms';
import { ref } from 'vue';

defineProps<{
  description?: string;
}>();

const modal = ref<InstanceType<typeof DialogModalFi> | null>(null);

function open() {
  modal.value?.open();
}

defineExpose({ open });
</script>

<style scoped src="./seminar-detail-dialog-fi" />
